import withPageTrack from '../../confirmation/withPageTrack';
import withPostTransactionRequest from '../../confirmation/withPostTransactionRequest';
import PendingView from '../../confirmation/PendingView';
import SuccessView from '../../confirmation/SuccessView';
import { withRouter } from "react-router-dom";

const FLOW = 'guest';
const POST_TRANSACTION_URL = '/donate/guest/postTransaction';

export const GuestConfirmationPending = withRouter(withPageTrack(
  withPostTransactionRequest(PendingView, POST_TRANSACTION_URL),
  FLOW,
  'pending'
));

export const GuestConfirmationSuccess = withRouter(withPageTrack(
  withPostTransactionRequest(SuccessView, POST_TRANSACTION_URL),
  FLOW,
  'success'
));
